import React from "react";
import {
  NumberFormatProps,
  default as NumberFormat,
} from "react-number-format";
import { useNumberField } from "./useNumberField";

interface NumberFieldProps extends NumberFormatProps {
  inputRef: (ref: HTMLInputElement | null) => void;
  handleChange?: (value: string) => void;
  digits?: number;
  decimalPlaces?: number;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  inputRef,
  handleChange,
  digits,
  decimalPlaces,
  ...props
}) => {
  const { placeholder, isAllowed } = useNumberField({
    digits,
    decimalPlaces,
  });
  return (
    <NumberFormat
      {...props}
      placeholder={placeholder}
      isAllowed={isAllowed}
      allowNegative={false}
      allowLeadingZeros={true}
      getInputRef={inputRef}
      onValueChange={({ value }) => {
        if (handleChange) {
          handleChange(value);
        }
      }}
    />
  );
};
